import React from 'react';
import { createRoot } from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import App from './App';
import { AuthTokenBridge } from './components/AuthTokenBridge';
import { AUTH0_AUDIENCE, AUTH0_CLIENT_ID, AUTH0_DOMAIN } from './services/authToken';
import './index.css';

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={AUTH0_DOMAIN}
      clientId={AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin,
        // Request access tokens for the backend API once its Auth0 audience is configured.
        ...(AUTH0_AUDIENCE ? { audience: AUTH0_AUDIENCE } : {}),
      }}
      // Refresh tokens keep silent token renewal working in browsers that block third-party cookies (requires
      // Refresh Token Rotation on the Auth0 application). Only enabled with token auth.
      useRefreshTokens={!!AUTH0_AUDIENCE}
      cacheLocation={AUTH0_AUDIENCE ? 'localstorage' : 'memory'}
    >
      <AuthTokenBridge />
      <App />
    </Auth0Provider>
  </React.StrictMode>
); 